<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">To the Extension and affiliated brothers and chapters</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172958_epub_ded_r1.vue?2c0f4072